import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FuseLoadingInterceptor } from '@fuse/services/loading/loading.interceptor';
import { FusePlatformService } from '@fuse/services/platform/platform.service';
import { FuseUtilsService } from '@fuse/services/utils/utils.service';

export const createFuseProviders = () => {
    return [
        {
            // Use the 'fill' appearance on Angular Material form fields by default
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'fill',
            },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FuseLoadingInterceptor,
            multi: true,
        },
        FusePlatformService,
        FuseUtilsService
    ];
};
